import { Dialog, DialogTitle, DialogContent, Grid, DialogActions, DialogContentText, Select, MenuItem, FormControl, TextField, TextareaAutosize, Box } from "@mui/material";
import { useState } from "react"

const AddCustomizedModal = (props: any) => {
  const { showAddModal, setShowAddModal } = props;
  const [inputValue, setInputValue] = useState({ name: '', description: '', templateCalendar: '' });
  const handleChange = (e: any) => {
    setInputValue({ ...inputValue, [e.target.name]: e.target.value })
  }
  console.log(inputValue);

  return (

    
    <Dialog
      className="view-calendar-modal"
      open={showAddModal}
      onClose={() => setShowAddModal(false)}
      maxWidth='sm'
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        className="Department-background fw-600 "
        sx={{ fontSize: "16px", mb: 3 }}
      >
        <p>Add Customised Vacations</p>
      </DialogTitle>
      <DialogContent className="content">
        <DialogContentText id="alert-dialog-description">
          <Grid container>
            <Grid item md={12} xs={12} display="flex" flexDirection="column">

              <label>
                Holiday Name <span>*</span>
              </label>
              <TextField
                size="small"
                value={inputValue.name}
                name="name"
                onChange={handleChange}
                type="text"
                placeholder="Enter Name"
                sx={{
                  mb: "30px",
                  "& label.Mui-focused": {
                    color: "#F78812",
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "#F78812",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#CCCCCC",
                    },
                    "&:hover fieldset": {
                      borderColor: "#F78812",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#F78812",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item md={12} xs={12} display="flex" flexDirection="column">
              <span> <label className="text-color fw-500 fs-14">Date </label>*</span>
              <TextField
                type="date"
                className="input"
                placeholder="Select"
                size="small"
                value={inputValue.description}
                name="description"
                onChange={handleChange}
                sx={{
                  mb: "30px",
                  "& label.Mui-focused": {
                    color: "#F78812",
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "#F78812",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#CCCCCC",
                    },
                    "&:hover fieldset": {
                      borderColor: "#F78812",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#F78812",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item md={12} xs={12} display="flex" flexDirection="column">
              <FormControl>
                <label className="fw-500 ">
                  Status <span>*</span>
                </label>
                <TextField
                  select
                  size="small"
                  value={inputValue.templateCalendar}
                  name="templateCalendar"
                  onChange={handleChange}
                  placeholder="Selcet"
                  sx={{
                    "& label.Mui-focused": {
                      color: "#F78812",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#F78812",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#CCCCCC",
                      },
                      "&:hover fieldset": {
                        borderColor: "#F78812",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#F78812",
                      },
                    },
                  }}
                >
                  <MenuItem >Vacation</MenuItem>
                  <MenuItem>No Vacation</MenuItem>
                </TextField>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ display: "flex", flexWrap: "wrap" }}>
        <Grid sx={{pl:1,mt:"100px"}} md={5} sm={12}>
          <button
            className="btn cancel text-color btn-light-grey"
            onClick={() => setShowAddModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn cancel save btn-secondary"
            onClick={() => setShowAddModal(false)}
          >
            Add
          </button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default AddCustomizedModal;
